import styled, { css } from "styled-components";
import { DataItemProps } from ".";

export const DataItemBox = styled.div<DataItemProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;

  ${(props) =>
    props.route &&
    css`
      span {
        color: ${(props) => props.theme.colors.labelTxt} !important;
      }

      div {
        font-weight: ${() => (props.fontWeight ? props.fontWeight : "600")};
      }
    `}
`;

export const DataLabelSpan = styled.p<any>`
  color: ${(props) => props.theme.colors.contentLabelTxt};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "1.2rem")};
  white-space: nowrap;
`;

export const DataContentBox = styled.div<DataItemProps>`
  color: ${(props) => props.theme.colors.contentTxt};
  font-size: ${(props) => (props.dateFontSize ? props.dateFontSize : "1.7rem")};
  white-space: pre-line;
  text-align: center;
  font-weight: 600;

  &.dispatchDate {
    white-space: nowrap;
  }
`;
